import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Person: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4168 5.25C11.4168 6.11195 11.0744 6.9386 10.4649 7.5481C9.85543 8.15759 9.02878 8.5 8.16683 8.5C7.30487 8.5 6.47822 8.15759 5.86873 7.5481C5.25924 6.9386 4.91683 6.11195 4.91683 5.25C4.91683 4.38805 5.25924 3.5614 5.86873 2.9519C6.47822 2.34241 7.30487 2 8.16683 2C9.02878 2 9.85543 2.34241 10.4649 2.9519C11.0744 3.5614 11.4168 4.38805 11.4168 5.25ZM11.9212 10.9895C13.0191 11.7664 13.8489 12.8646 14.2963 14.1329C14.3311 14.2309 14.3418 14.3358 14.3275 14.4389C14.3133 14.5419 14.2746 14.64 14.2146 14.7249C14.1546 14.8099 14.0751 14.8792 13.9828 14.9271C13.8905 14.9749 13.788 14.9999 13.684 15H2.64963C2.54563 14.9999 2.44317 14.9749 2.35084 14.9271C2.25852 14.8792 2.17902 14.8099 2.11904 14.7249C2.05905 14.64 2.02032 14.5419 2.0061 14.4389C1.99189 14.3358 2.00259 14.2309 2.03733 14.1329C2.37177 13.1851 2.92146 12.3277 3.64322 11.6281C4.36498 10.9286 5.23913 10.406 6.19698 10.1014C7.15482 9.79676 8.17027 9.71842 9.16351 9.87252C10.1567 10.0266 11.1007 10.409 11.9212 10.9895Z"
      fill="currentColor"
    />
  </svg>
);
